type Environment =
  | 'local'
  | 'development'
  | 'testing'
  | 'production'
  | 'testing7';

interface Domain {
  apiDomain: string;
  walnutcupDomain: string;
  contestIdeDomain: string;
  contestPythonIdeDomain: string;
}

type AllDomain = {
  [key in Environment]: Domain;
};

interface DEBUG_ENV_TYPE {
  environment: Environment; // 强制替换环境
  cheat: boolean; // 停止防作弊功能
  showBrand: boolean; // 停止防作弊功能
}

/**
 * 可以在非线上环境关闭掉防作弊功能
 * 也可以强制替换环境
 *
 * @return {*}
 */
function getDebugEnv() {
  let result: DEBUG_ENV_TYPE;
  try {
    const str = localStorage.getItem('debugEnv');
    result = JSON.parse(str || '{}');
  } catch (e) {
    result = {} as DEBUG_ENV_TYPE;
  }
  return result;
}

export const DEBUG_ENV = getDebugEnv();

export function extractUrlValue(key: string, url?: string) {
  if (typeof url === 'undefined') url = window.location.search;
  const match = url.match('[?&]' + key + '=([^&]+)');
  return match ? match[1] : null;
}

export function getEnvironment(): Environment {
  if (process.env.NODE_ENV === 'development') {
    if (process.env.VUE_DEV_ENV_MODE?.startsWith('testing')) {
      return process.env.VUE_DEV_ENV_MODE as Environment;
    }
    return DEBUG_ENV.environment || 'local';
  }

  const hostname = window.location.hostname;

  if (hostname.indexOf('hetaodev') >= 0) {
    return DEBUG_ENV.environment || 'development';
  }

  if (hostname.indexOf('testing7') >= 0) {
    return DEBUG_ENV.environment || 'testing7';
  }

  if (hostname.indexOf('testing') >= 0) {
    return DEBUG_ENV.environment || 'testing';
  }

  return 'production';
}

export function getShowBrand() {
  if ('showBrand' in DEBUG_ENV) {
    return DEBUG_ENV.showBrand;
  }

  const hostname = window.location.hostname;
  // 这里只是维护了漏出品牌信息的域名
  // 所有其他域名都是默认不漏出品牌信息
  const SHOW_BRAND_DOMAINS = [
    // 'localhost',
    'contest.hetaodev.com',
    'match.testing7.hetao101.com',
    'match.testing.hetao101.com',
    'match.hetao101.com',
  ];
  return SHOW_BRAND_DOMAINS.includes(hostname);
}

const allDomain: AllDomain = {
  local: {
    apiDomain: '',
    walnutcupDomain: `https://walnutcup.testing.hetao101.com`,
    // contestIdeDomain: `https://contest.hetaodev.com`,
    contestIdeDomain: `https://match.testing.hetao101.com`,
    contestPythonIdeDomain: 'https://kp.huodong.codeclass888.com',
  },
  development: {
    apiDomain: 'https://contest.hetaodev.com',
    walnutcupDomain: `https://walnutcup.testing7.hetao101.com`,
    contestIdeDomain: `https://contest.hetaodev.com`,
    contestPythonIdeDomain: 'https://kp.huodong.codeclass888.com',
  },
  testing: {
    apiDomain: 'https://match.testing.hetao101.com',
    walnutcupDomain: `https://walnutcup.testing.hetao101.com`,
    contestIdeDomain: `https://match.testing.hetao101.com`,
    contestPythonIdeDomain: 'https://kp.huodong.codeclass888.com',
  },
  testing7: {
    apiDomain: 'https://match.testing7.hetao101.com',
    walnutcupDomain: `https://walnutcup.testing7.hetao101.com`,
    contestIdeDomain: `https://match.testing7.hetao101.com`,
    contestPythonIdeDomain: 'https://kp.huodong.codeclass888.com',
  },
  production: {
    apiDomain: 'https://match.hetao101.com',
    walnutcupDomain: `https://walnutcup.hetao101.com`,
    contestIdeDomain: `https://match.hetao101.com`,
    contestPythonIdeDomain: 'https://kp.codeclass888.com',
  },
};

export const environment = getEnvironment();

export const SHOW_BRAND = getShowBrand();

export const domains = allDomain[environment];

export function getTagName() {
  return extractUrlValue('tag') || '-1';
}

export function handlerMetaPlugin() {
  return {
    install() {
      if (SHOW_BRAND) {
        document
          .querySelector('meta[name="description"]')
          ?.setAttribute(
            'content',
            '核桃编程来自美国图形化编程实验室教研体系，由麻省理工Yasmin Kafai教授、宾夕法尼亚大学认知科学专家曾鹏轩倾力研发，世界机器人大赛冠军王宇航亲授，采用进阶式课堂、游戏化趣味教学，让孩子遵循教育规律快乐学习，激发学习主动性，零基础启蒙到轻松搞定编程！'
          );
        document
          .querySelector('meta[name="keywords"]')
          ?.setAttribute(
            'content',
            '核桃编程,核桃编程营,核桃编程官网,核桃少儿编程,核桃教育,在线少儿编程,少儿编程机构,少儿编程教育平台,少儿编程'
          );
      }
    },
  };
}

export function isInIframe() {
  return window.self !== window.top;
}
